export default "__VITE_ASSET__b36aJAVf__"